var map = {
	"./dispo-1.png": "./assets/img/dispo-1.png",
	"./dispo-2.png": "./assets/img/dispo-2.png",
	"./dispo-3.png": "./assets/img/dispo-3.png",
	"./dispo-4.png": "./assets/img/dispo-4.png",
	"./dispo-5.png": "./assets/img/dispo-5.png",
	"./dispo-6.png": "./assets/img/dispo-6.png",
	"./dispo-7.png": "./assets/img/dispo-7.png",
	"./espace-dessous-grand.png": "./assets/img/espace-dessous-grand.png",
	"./espace-dessous-moyen.png": "./assets/img/espace-dessous-moyen.png",
	"./espace-dessous-petit.png": "./assets/img/espace-dessous-petit.png",
	"./espace-dessous-zero.png": "./assets/img/espace-dessous-zero.png",
	"./espace-dessus-grand.png": "./assets/img/espace-dessus-grand.png",
	"./espace-dessus-moyen.png": "./assets/img/espace-dessus-moyen.png",
	"./espace-dessus-petit.png": "./assets/img/espace-dessus-petit.png",
	"./espace-dessus-zero.png": "./assets/img/espace-dessus-zero.png",
	"./horizontal-center.png": "./assets/img/horizontal-center.png",
	"./horizontal-left.png": "./assets/img/horizontal-left.png",
	"./horizontal-right.png": "./assets/img/horizontal-right.png",
	"./icone-implantation.png": "./assets/img/icone-implantation.png",
	"./icone-regleblanc.png": "./assets/img/icone-regleblanc.png",
	"./icone-reglebleu.png": "./assets/img/icone-reglebleu.png",
	"./icone-rendement.png": "./assets/img/icone-rendement.png",
	"./icone-youtube.png": "./assets/img/icone-youtube.png",
	"./icone-zoom-qualite.png": "./assets/img/icone-zoom-qualite.png",
	"./image-fallback.jpg": "./assets/img/image-fallback.jpg",
	"./vertical-bottom.png": "./assets/img/vertical-bottom.png",
	"./vertical-center.png": "./assets/img/vertical-center.png",
	"./vertical-stretch.png": "./assets/img/vertical-stretch.png",
	"./vertical-top.png": "./assets/img/vertical-top.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/img sync \\.(png%7Cjpe?g%7Cgif)$";